<template>
  <div class="price-per-person-dropdown">
    <!-- "Cena za osobę" czy "Cena"? Jak backend traktuje tę wartość?-->
    <div class="price-per-person-dropdown__label">Cena za osobę</div>

    <RadioList ref="list" class="price-per-person-dropdown__body"
      :options="options"
      v-model="selected"
      @input="$emit('input', selected)" />
  
  </div>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

import RadioList from '@/components/RadioList.vue'

@Component({
  components: {
    RadioList,
  },
  props: {
    value: {
      type: String,
      required: true,
      nullable: true,
    },
    options: {
      type: Array,
      required: true,
    },
  },
  watch: {
    value (newValue) {
      this.selected = newValue
    },
  },
})
export default class PricePerPerson extends Vue {
  selected = this.value
}
</script>

<style lang="scss" scoped>
@import '../filter.scss';

.price-per-person-dropdown {
  @include filter(#005CAA);

  &__body {
    @include filter-body(#545454, 12px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/search/fields/PricePerPersonDropdown.vue